// extracted by mini-css-extract-plugin
export default {"component":"CardsGrid__component--lc-QRiU2","list":"CardsGrid__list--lc-Avq0f","item":"CardsGrid__item--lc-EMFyo"};